import { localPlans } from "@/config/plans.config";
import { localOldPlans } from "@/config/plans-old.config";
import { localMeliPlans } from "@/config/plans-meli.config";
import { LocalPlansType } from "@/types/PlansType";
const activeMeli: boolean = process.env.VUE_APP_ACTIVE_MELI === "true";
const activeOld: boolean = process.env.VUE_APP_ACTIVE_OLD === "true";

/** Planos do novo catalogo */
const plans = process.env.VUE_APP_HOME_PLANS.split("|");
/** Planos do novo catalogo */

const pageB: string[] = plans;

const home: string[] = plans;

export const getHomePlans = async (page: string): Promise<LocalPlansType[]> => {
  const plans: LocalPlansType[] = localPlans;

  if (activeOld) {
    plans.push(...localOldPlans);
  }

  if (page === "HOME") {
    return plans.filter((plan) => home.includes(plan.id));
  }

  return plans.filter((plan) => pageB.includes(plan.id));
};

export const getAllLocalPlans = async (): Promise<LocalPlansType[]> => {
  const plans: LocalPlansType[] = localPlans;

  if (activeOld) {
    plans.push(...localOldPlans);
  }

  if (activeMeli) {
    plans.push(...localMeliPlans);
  }

  return plans;
};
